import styled from 'styled-components';
import { Input } from 'antd';

export const TopContainer = styled.div`
  display: flex;
  width: 1200px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  font-family: 'Pretendard', sans-serif;
`;

export const TopHeaderWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

export const TopHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  align-self: stretch;
`;
export const TopHeaderTitleFont = styled.div`
  color: ${({ theme }) => theme.COLORS.itemTitle};
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TopHeaderNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;
export const TopHeaderNavTaps = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;
export const TopHeaderNavTapsItem = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>`
  display: flex;
  padding: 12px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  font-size: 16px;
  //border-bottom: 2px solid ${({ theme }) => theme.COLORS.itemTitle};

  border-bottom: ${({ active, theme }) =>
    active ? `2px solid ${theme.COLORS.itemTitle}` : 'none'};

  color: ${({ active, theme }) =>
    active ? theme.COLORS.itemTitle : theme.COLORS.tabMenuInactive};
`;

export const TopHeaderNavSearch = styled.div`
  display: flex;
  width: 400px;
  height: 36px;
  padding: 10px 12px;
  align-items: center;
  gap: 6px;
`;

export const TopContentWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const TradeCardContainer = styled.div`
  display: flex;
  width: 290px;
  padding: 20px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;

  border-radius: 6px;
  background: radial-gradient(
      75.57% 66.09% at 50% -6.01%,
      rgba(255, 145, 49, 0.1) 0%,
      rgba(20, 17, 34, 0.1) 100%
    ),
    ${({ theme }) => theme.COLORS.listIconBorder};
`;

export const TradeCardSection1 = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;
export const TradeCardSection1Avatar = styled.div`
  width: 60px;
  height: 60px;
`;
export const TradeCardSection1ContentWarp = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-family: 'Pretendard', sans-serif;
  gap: 8px;
`;
export const TradeCardSection1ContentTitle = styled.div`
  color: ${({ theme }) => theme.COLORS.itemTitle};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const TradeCardSection1ContentDesc = styled.div`
  display: flex;

  color: ${({ theme }) => theme.COLORS.itemContent};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
export const TradeCardSection1ContentDescPosi = styled.div`
  color: ${({ theme }) => theme.COLORS.positiveItem};
  margin-left: 6px;
`;

export const TradeCardSectionDescWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 33px;
  align-self: stretch;
`;

export const TradeCardSection2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  font-family: 'Pretendard', sans-serif;
`;
export const TradeCardSection2Content1 = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: ${({ theme }) => theme.COLORS.descText};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
export const TradeCardSection2Content2 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;

  color: ${({ theme }) => theme.COLORS.positiveItem};
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const TradeCardSection3 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;
export const TradeCardSection3Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;
export const TradeCardSection3ContentLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.COLORS.descText};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
export const TradeCardSection3ContentRight = styled.div`
  color: ${({ theme }) => theme.COLORS.itemTitle};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const TradeCardBtn = styled.div`
  display: flex;
  padding: 12px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 2px;
  background: ${({ theme }) => theme.COLORS.tabMenuActive};
  color: #fff;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const BottomContainer = styled.div`
  display: flex;
  width: 1200px;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  font-family: 'Pretendard', sans-serif;
  margin-top: 20px;

  @media (max-width: 1024px) {
    width: 100%;
    padding: 0 16px;
    gap: 16px;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
    gap: 12px;
    margin-top: 12px;
  }
`;
export const BottomHeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;
export const BottomHeaderTitle = styled.div`
  color: ${({ theme }) => theme.COLORS.itemTitle};
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const StyledSearch = styled(Input.Search)`
  width: 240px;

  .ant-input-group-addon {
    button {
      color: ${({ theme }) => theme.COLORS.searchText} !important;
    }
  }
`;

export const BottomContentWrap = styled.div`
  width: 100%;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, 1fr);

  margin-bottom: 24px;

  /* 반응형 그리드 */
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
  }
`;
